<app-page-loader text="Signing out..."></app-page-loader>
